import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "ws_token";

// Tokens live in sessionStorage so they don't persist beyond the tab and
// have a slightly smaller XSS surface than localStorage. For maximal security
// migrate to httpOnly cookies on a custom domain (requires CSRF + cookie config).
export const tokenStore = {
  get: () => sessionStorage.getItem(TOKEN_KEY),
  set: (t) => sessionStorage.setItem(TOKEN_KEY, t),
  clear: () => sessionStorage.removeItem(TOKEN_KEY),
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 401) {
      tokenStore.clear();
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register")) {
        window.location.href = "/login";
      }
    } else if (status === 402) {
      const path = window.location.pathname;
      if (!path.startsWith("/pricing") && !path.startsWith("/billing")) {
        window.location.href = "/pricing";
      }
    } else if (status === 403 && detail && detail.error === "upgrade_required") {
      window.dispatchEvent(new CustomEvent("ws:upgrade-required", { detail }));
    }
    return Promise.reject(err);
  }
);

export default client;

/**
 * Extract a human-readable error string from an axios error.
 * Handles structured detail objects (e.g. {error, message}) and arrays.
 */
export function errMessage(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || x?.message || JSON.stringify(x)).join("; ");
  if (typeof d === "object") return d.message || d.error || JSON.stringify(d);
  return fallback;
}
